import { type TableColumnSpec } from "#blocks/Table/buildTableColumns"
import { USER_ROLES } from "#customTypes/composedTypes/authTypes"
import { USER_GENDERS } from "#customTypes/composedTypes/userTypes"
import { camelToWords } from "#utils/textFormatters"

export const USER_TABLE_COLUMNS: TableColumnSpec[] = [
  { key: "name", width: 200 },
  { key: "role", width: 130 },
  { key: "email", width: 220 },
  { key: "hasPin", width: 80, align: "center" },
  { key: "phone", width: 130 },
  { key: "address", width: 250 },
  { key: "notes", width: 200 },
  { key: "tags", width: 120, ellipsis: false },
  { key: "allergies", width: 120, ellipsis: false },
  { key: "lastUpdatedAt", width: 140, title: "Last Updated" },
]

export const USER_SORTABLE_FIELDS = [
  "name",
  "role",
  "email",
  "phone",
  "lastUpdatedAt",
] as const

export const USER_ROLE_OPTIONS = Object.values(USER_ROLES).map((role) => {
  return {
    value: role,
    label: camelToWords(role),
  }
})

export const USER_GENDER_OPTIONS = Object.values(USER_GENDERS).map(
  (gender) => ({
    value: gender,
    label: camelToWords(gender),
  })
)

export const USER_PRONOUNS = {
  HE: "HE",
  SHE: "SHE",
  THEY: "THEY",
} as const

export const USER_PRONOUN_OPTIONS = Object.values(USER_PRONOUNS).map(
  (pronoun) => ({
    value: pronoun,
    label: camelToWords(pronoun),
  })
)
